// extracted by mini-css-extract-plugin
module.exports = {"first_review":"styles_first_review__1AUSF","rating__wrapper":"styles_rating__wrapper__3Ofjt"};